<template>
  <div class="history-templates">
    <el-button size="small" plain icon="el-icon-time" :disabled="disabled || !templateId" @click="open">从历史选择</el-button>
    <span>复用本人提交过的同类审批，修改后重新提交</span>
    <el-dialog title="选择历史申请" :visible.sync="visible" width="620px" append-to-body :close-on-click-modal="false" @closed="cancel">
      <p>选择后会替换当前填写内容。签名、审批结果和审批人不会复制，请核对日期、金额及附件。</p>
      <div v-loading="loading">
        <el-button v-if="loadError && !loading" @click="load(page)">加载失败，点击重试</el-button>
        <el-empty v-else-if="!loading && !records.length" description="暂无同类审批历史" />
        <div v-for="item in records" :key="item.processInstanceId" class="history-row">
          <div><strong>{{ item.name || '历史申请' }}</strong><small>{{ time(item.startTime) }} · {{ status(item.status) }}</small></div>
          <el-button size="small" :loading="choosing === item.processInstanceId" :disabled="!!choosing" @click="choose(item)">使用此申请</el-button>
        </div>
      </div>
      <el-pagination v-if="total > 20" layout="prev, pager, next" :page-size="20" :total="total" :current-page="page" @current-change="load" />
      <span slot="footer"><el-button @click="visible=false">取消</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {templateId: [String, Number], disabled: Boolean},
  data: () => ({visible:false, loading:false, loadError:false, records:[], total:0, page:1, choosing:'', epoch:0}),
  beforeDestroy() {this.cancel()},
  deactivated() {this.visible=false;this.cancel()},
  watch: {templateId() {this.visible=false;this.cancel()}},
  methods: {
    time(value) {return value ? String(value).replace('T',' ').replace(/\.\d+.*$/, '').slice(0,19) : ''},
    status(value) {return ({'1':'审批中','2':'已撤销','3':'已驳回','4':'已通过',PROCESSING:'审批中',COMPLETED:'已通过',REJECTED:'已驳回',CANCELED:'已撤销',CANCELLED:'已撤销'})[value] || '历史申请'},
    open() {this.visible=true;this.records=[];this.total=0;this.load(1)},
    cancel() {this.epoch++;this.loading=false;this.choosing='';this.$emit('busy',false)},
    async load(page) {
      const epoch=++this.epoch;this.page=page;this.loading=true;this.loadError=false;
      try {
        const res=await this.$api.workflowHistoryTemplates({templateId:this.templateId,pageNo:page,pageSize:20});
        if(epoch!==this.epoch)return;
        if(res.code!==0)throw new Error(res.message || '加载历史失败');
        this.records=res.data.records;this.total=res.data.total;
      } catch(error) {if(epoch===this.epoch){this.records=[];this.loadError=true;this.$message.error(error.message || '加载历史失败，请重试')}}
      finally {if(epoch===this.epoch)this.loading=false}
    },
    async choose(item) {
      if(this.choosing)return;
      try {await this.$confirm('将替换当前表单内容，是否使用这条历史申请？','使用历史申请',{type:'warning'})} catch {return}
      if(!this.visible)return;
      const epoch=++this.epoch;this.choosing=item.processInstanceId;this.$emit('busy',true);
      try {
        const res=await this.$api.workflowHistoryTemplate({templateId:this.templateId,processInstanceId:item.processInstanceId});
        if(epoch!==this.epoch)return;
        if(res.code!==0)throw new Error(res.message || '读取历史失败');
        this.$emit('select',res.data);this.visible=false;
      } catch(error) {if(epoch===this.epoch)this.$message.error(error.message || '读取历史失败，请重试')}
      finally {if(epoch===this.epoch){this.choosing='';this.$emit('busy',false)}}
    }
  }
}
</script>
<style scoped>
.history-templates{margin:12px 0 20px}.history-templates>span{display:block;color:#869099;font-size:12px;margin-top:8px}
.history-row{display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 0;border-bottom:1px solid #edf2f2}.history-row>div{min-width:0}.history-row strong{display:block;overflow-wrap:anywhere}.history-row small{display:block;margin-top:6px;color:#869099}
</style>
